import { NgModule } from "@angular/core";
import { PopupLoaderModule, SharedModule } from "@app/shared";
import { AllPipesModule } from "@app/shared/pipes/all-pipes.module";
import { ScheduleCallbackViewModalComponent } from "./schedule-callback-view-modal.component";

@NgModule({
  declarations: [ScheduleCallbackViewModalComponent],
  imports: [
    SharedModule,PopupLoaderModule,AllPipesModule
  ],
  entryComponents: [ScheduleCallbackViewModalComponent],
})
export class ScheduleCallbackViewModalModule { }